import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import '../../Form.css';
import { getDefaultValues } from 'ra-core';
import {
  renderPhoneField,
  renderField,
  nameValidation,
  phoneValidation,
  formatPhone,
  normalizePhone,
  STATUSES,
  VISITED,
  renderSelectField, required
} from '../../../common';
import DateTimeEditor from '../../../components/DateTimeEditor';

const normalizeBoolean = value => {
  if (value === 'true') {
    return true;
  }

  if (value === 'false') {
    return false;
  }

  return value;
};

let Edit = props => {
  const { handleSubmit, companies, submitting, subjects } = props;
  return (
    <form className="ScForm" onSubmit={handleSubmit}>
      <div>
        <h2>Редактирование записи</h2>
        <div>
          <Field
            name="companyId"
            component="select"
          >
            {companies.map(({ id, name }) => <option key={id} value={id}>{name}</option>)}
          </Field>
        </div>
      </div>
      <div>
        <div className="ScFormRow_50">
          <label>Дата создания</label>
          <Field dateDisable timeDisable name="_createdAt" component={DateTimeEditor} />
        </div>
      </div>
      <div>
        <div className="ScFormRow_50">
          <label>Дата записи</label>
          <Field name="time" component={DateTimeEditor} />
        </div>
      </div>
      <div className="ScFormRow_50">
        <div className="ScFormCol_50_left">
          <Field name="pin" component="input" type="text" disabled />
        </div>
        <div className="ScFormCol_50_right">
          <Field name="status_callcenter" component="select">
            {STATUSES.map(({ id, name, color }) => <option key={id} value={id} style={{ color }}>{name}</option>)}
          </Field>
        </div>
      </div>
      <div>
        <label>ФИО*</label>
        <Field name="fio" autoComplete="off" type="text" placeholder="" component={renderField} validate={nameValidation}  />
      </div>
      <div className="ScFormRow_50">
        <div className="ScFormCol_50_left">
          <label>Телефон*</label>
          <Field
            name="phone"
            autoComplete="off"
            data-lpignore
            type="tel"
            component={renderPhoneField}
            validate={phoneValidation}
            format={formatPhone}
            normalize={normalizePhone}
          />
        </div>
        <div className="ScFormCol_50_right">
          <label>Email</label>
          <Field name="email" autoComplete="off" component="input" type="email" placeholder="Email" />
        </div>
      </div>
      <div>
        <div className="ScFormRow_50">
          <label>Тематика</label>
          <Field name="subject_new" component={renderSelectField} validate={required}>
            <option key={null} value={null} disabled> </option>
            {subjects.map(({ key, name }) => <option key={key} value={key}>{name}</option>)}
          </Field>
        </div>
      </div>
      <div>
        <label>Тематика (old)</label>
        <Field disabled name="subject" autoComplete="off" component="input" type="text" placeholder="" />
      </div>
      <div>
        <label>Вопрос</label>
        <Field name="subject_text" autoComplete="off" component="textarea" style={{ height: '58px' }} />
      </div>
      <div>
        <div className="ScFormRow_50">
          <div className="ScFormCol_50_left">
            <label className="ScFormPurple">Приход</label>
            <Field name="visited" component="select">
              {VISITED.map(({ id, name, color }) => <option key={id} value={id} style={{ color }}>{name}</option>)}
            </Field>
          </div>
          <div className="ScFormCol_50_right">
            <label>Договор</label>
            <Field name="treaty" component="select" normalize={normalizeBoolean}>
              <option value>Да</option>
              <option value={false}>Нет</option>
            </Field>
          </div>
        </div>
        <div>
          <label>Комментарий Юр Фирмы</label>
          <Field name="comment" component="textarea" style={{ height: '48px' }} />
        </div>
        <div>
          <label>Комментарий Админа</label>
          <Field name="adminComment" component="textarea" style={{ height: '48px' }} />
        </div>
        <div style={{ height: '20px' }}>
          <label style={{
            display: 'block',
            height: '15px',
            left: '22px',
            position: 'relative'
          }}
          >Лид украден
          </label>
          <Field
            style={{
              position: 'relative',
              top: '-28px'
            }}
            name="busted"
            id="busted"
            component="input"
            text="hui"
            type="checkbox"
          />
        </div>
      </div>

      <div>
        <button type="submit" disabled={submitting}>
          Сохранить изменения
        </button>
      </div>

    </form>
  );
};


Edit = reduxForm({
  form: 'edit1'
})(Edit);

Edit = connect((state, props) => ({
  initialValues: getDefaultValues(state, props),
  saving: props.saving || state.admin.saving
}))(Edit);

export default Edit;



// WEBPACK FOOTER //
// ./src/pages/admin/customer/Edit.js